<template>
  <Teleport v-if="isVisible" to="body">
    <slot />
  </Teleport>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, useBlokkli } from "#imports";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true }
});
const { debug } = useBlokkli();
const isVisible = computed(
  () => debug.isEnabled.value && debug.overlays.value.find((v) => v.id === props.id)?.active
);
onMounted(() => {
  debug.registerOverlay(props.id, props.title);
});
onBeforeUnmount(() => {
  debug.unregisterOverlay(props.id);
});
defineOptions({
  name: "DebugOverlay"
});
</script>
